/**
 * A line in the accent that opens a paragraph or two beneath it — how to read
 * a trade-off, how to read the tree — its chevron turning as it opens. A
 * native <details>, so the keyboard and assistive technology have the
 * disclosure pattern with nothing to wire.
 *
 *   <Disclosure summary="How to interpret these tradeoffs"><p>…</p></Disclosure>
 *
 * It is set as a caption line; where it sits is the caller's `className`.
 */

import type { ReactNode } from 'react';

import { GLYPH } from './glyphs';
import { Icon } from './icon';
import utilities from '../../styles/utilities.module.css';
import styles from './disclosure.module.css';

interface DisclosureProps {
  /** The line that opens it. */
  summary: ReactNode;
  /** What it opens: a paragraph or two. */
  children: ReactNode;
  className?: string;
}

export function Disclosure({ summary, children, className = '' }: DisclosureProps) {
  return (
    <details className={[utilities.captionLine, className].filter(Boolean).join(' ')}>
      <summary className={styles.summary}>
        <Icon glyph={GLYPH.chevronRight} size="sm" className={utilities.turning} />
        {summary}
      </summary>
      <div className={styles.body}>{children}</div>
    </details>
  );
}
